module.exports = __webpack_public_path__ + "images/icons_v2/chevron-left-1636f877.svg";